// Generated by CoffeeScript 1.6.3
module.exports = {
  pad: function(n, width, z) {
    if (z == null) {
      z = '0';
    }
    n = n + '';
    if (n.length >= width) {
      return n;
    } else {
      return new Array(width - n.length + 1).join(z) + n;
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/utila/lib/string.js
// module id = 4026
// module chunks = 0